import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import BASE_URL from "api/Api";
import { FaArrowLeft, FaFlag, FaUpload, FaSave, FaImage } from "react-icons/fa";
import "assets/theme/admin_form.css";

const AddParty = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    party_name: "",
    short_name: "",
    symbol: null,
    preview: null,
  });

  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prev) => ({
        ...prev,
        symbol: file,
        preview: URL.createObjectURL(file),
      }));
      if (errors.symbol) {
        setErrors((prev) => ({ ...prev, symbol: "" }));
      }
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.party_name.trim()) {
      newErrors.party_name = "Party Name is required";
    }
    if (!formData.short_name.trim()) {
      newErrors.short_name = "Short Name is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;
    setSubmitting(true);

    const payload = new FormData();
    payload.append("party_name", formData.party_name);
    payload.append("short_name", formData.short_name);
    if (formData.symbol) {
      payload.append("symbol_image", formData.symbol);
    }

    try {
      const res = await fetch(`${BASE_URL}super_admin/add_parties`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: payload,
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.message || "Failed to create party");
      }

      alert("Party created successfully");
      navigate("/party-list");
    } catch (error) {
      console.error(error);
      alert(error.message || "Failed to fetch");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="container-fluid py-3 admin-form-container">
        {/* Header Card with Left Back Arrow */}
        <div className="admin-form-header-card">
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 position-relative" style={{ zIndex: 1 }}>
            <div className="d-flex align-items-center gap-3">
              <button
                type="button"
                onClick={() => navigate("/party-list")}
                className="btn-admin-back"
                title="Back to Party List"
              >
                <FaArrowLeft /> <span>मागे जा (Back)</span>
              </button>

              <div className="admin-header-icon">
                <FaFlag />
              </div>

              <div>
                <h4 className="text-white fw-bold mb-0" style={{ fontSize: "1.25rem" }}>
                  नवीन राजकीय पक्ष जोडा / Add Political Party
                </h4>
                <p className="text-white-50 mb-0 small">
                  Fill details to register a new political party and symbol
                </p>
              </div>
            </div>

            <Link to="/party-list" className="btn btn-outline-light btn-sm fw-semibold rounded-pill px-3">
              Party List / यादी
            </Link>
          </div>
        </div>

        {/* Form Card */}
        <div className="admin-form-card">
          <div className="card-body">
            <form onSubmit={handleSubmit} noValidate>
              <div className="row g-4">
                {/* Party Name */}
                <div className="col-md-6">
                  <label className="admin-form-label">
                    Party Name / पक्षाचे नाव <span className="required-star">*</span>
                  </label>
                  <input
                    type="text"
                    className={`admin-form-control ${errors.party_name ? "border-danger" : ""}`}
                    name="party_name"
                    value={formData.party_name}
                    onChange={handleChange}
                    placeholder="e.g. Bharatiya Janata Party / भारतीय जनता पार्टी"
                  />
                  {errors.party_name && (
                    <small className="text-danger fw-semibold d-block mt-1">{errors.party_name}</small>
                  )}
                </div>

                {/* Short Name */}
                <div className="col-md-6">
                  <label className="admin-form-label">
                    Short Name / पक्षाचे संक्षिप्त नाव <span className="required-star">*</span>
                  </label>
                  <input
                    type="text"
                    className={`admin-form-control text-uppercase ${errors.short_name ? "border-danger" : ""}`}
                    name="short_name"
                    value={formData.short_name}
                    onChange={handleChange}
                    placeholder="e.g. BJP"
                  />
                  {errors.short_name && (
                    <small className="text-danger fw-semibold d-block mt-1">{errors.short_name}</small>
                  )}
                </div>

                {/* Symbol Upload */}
                <div className="col-12">
                  <label className="admin-form-label">Party Symbol Image / चिन्ह प्रतिमा</label>

                  <div className="admin-file-box">
                    {formData.preview ? (
                      <div className="d-flex flex-column align-items-center">
                        <img
                          src={formData.preview}
                          alt="Preview"
                          className="mb-3 rounded-circle border shadow-sm"
                          style={{
                            width: "90px",
                            height: "90px",
                            objectFit: "cover",
                          }}
                        />
                        <span className="badge bg-success bg-opacity-10 text-success fw-semibold px-3 py-1 mb-2">
                          Symbol selected
                        </span>
                      </div>
                    ) : (
                      <div className="py-2">
                        <FaImage className="text-muted mb-2" style={{ fontSize: "2.2rem" }} />
                        <p className="text-muted small mb-2">Drag & drop or click to upload symbol image</p>
                      </div>
                    )}

                    <label className="btn btn-outline-primary btn-sm px-4 rounded-pill">
                      <FaUpload className="me-1" />
                      {formData.preview ? "Change Symbol Image" : "Choose Image File"}
                      <input
                        type="file"
                        hidden
                        accept="image/*"
                        onChange={handleFileChange}
                      />
                    </label>

                    <small className="text-muted d-block mt-2">
                      Recommended size: 200x200px PNG/JPG
                    </small>
                  </div>
                </div>
              </div>

              {/* Form Action Buttons */}
              <div className="d-flex align-items-center justify-content-end gap-3 mt-4 pt-3 border-top">
                <Link to="/party-list" className="btn-admin-cancel">
                  रद्द करा (Cancel)
                </Link>
                <button
                  type="submit"
                  className="btn-admin-submit"
                  disabled={submitting}
                >
                  <FaSave />
                  <span>{submitting ? "जतन होत आहे..." : "जतन करा (Save Party)"}</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default AddParty;
